module.exports = __webpack_public_path__ + "img/character-logistic-slots.32d5e88f.png";